// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
// import {Link} from "react-router-dom";
import {Button, Popover, Table} from "antd";
import * as Setting from "../../conf/Setting";
import * as SyncerBackend from "../../services/SyncerBackend";
import i18next from "i18next";
import BaseListPage from "../../components/basic/BaseListPage";
import UpstreamSyncerLogDetailPage from "./UpstreamSyncerLogDetailPage";

class UpstreamSyncerLogPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      showLogDetail: false,
      record: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.state.pagination.pageSize = 20;
    const {pagination} = this.state;
    this.fetch({pagination});
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.state.pagination.pageSize = 20;
      const {pagination} = this.state;
      this.fetch({pagination});
    }
  }

  renderTable(records) {
    const columns = [
      {
        title: i18next.t("general:Number"),
        dataIndex: "index",
        key: "index",
        width: (Setting.isMobile()) ? "60px" : "100px",
        fixed: "left",
        align: "center",
        render: (text, record, index) => `${index + 1}`,
      },
      {
        title: i18next.t("syncer:Sync type"),
        dataIndex: "syncType",
        key: "syncType",
        width: "150px",
        render: (text, record, index) => {
          if (text === 0) {
            return i18next.t("syncer:User sync");
          }
          if (text === 1) {
            return i18next.t("syncer:Department sync");
          }
          return i18next.t("syncer:Relationship sync");
        },
      },
      {
        title: i18next.t("syncer:Sync mode"),
        dataIndex: "isAuto",
        key: "isAuto",
        width: "120px",
        filterMultiple: false,
        filters: [
          {text: i18next.t("syncer:Automatic"), value: "1"},
          {text: i18next.t("syncer:Manual"), value: "0"},
        ],
        render: (text, record, index) => {
          if (text) {
            return i18next.t("syncer:Automatic");
          }
          return i18next.t("syncer:Manual");
        },
      },
      {
        title: i18next.t("syncer:Sync start time"),
        dataIndex: "startTime",
        key: "startTime",
        width: "200px",
        sorter: true,
      },
      {
        title: i18next.t("syncer:Sync end time"),
        dataIndex: "endTime",
        key: "endTime",
        width: "200px",
        sorter: true,
      },
      {
        title: i18next.t("syncer:State"),
        dataIndex: "status",
        key: "status",
        width: "110px",
        filterMultiple: false,
        filters: [
          {text: i18next.t("syncer:Success"), value: "1"},
          {text: i18next.t("syncer:Fail"), value: "0"},
        ],
        render: (text, record, index) => {
          if (text) {
            return i18next.t("syncer:Success");
          }
          return i18next.t("syncer:Fail");
        },
      },
      {
        title: i18next.t("general:Action"),
        dataIndex: "action",
        key: "action",
        width: "200px",
        fixed: (Setting.isMobile()) ? "false" : "right",
        render: (text, record, index) => {
          return (
            <div>
              {
                record.status ?
                  <Button style={{marginRight: "10px"}} type="link"
                    onClick={() => {this.setState({record: record, showLogDetail: true});}}>{i18next.t("syncer:Detail")}</Button>
                  :
                  <Popover content={record.errorInfo} placement="bottomRight">
                    <Button style={{marginRight: "10px"}} type="link">{i18next.t("syncer:Failed reason")}</Button>
                  </Popover>
              }
            </div>
          );
        },
      },
    ];

    const paginationProps = {
      total: this.state.pagination.total,
      pageSize: this.state.pagination.pageSize,
      showQuickJumper: true,
      showSizeChanger: true,
      showTotal: () => i18next.t("general:{total} in total").replace("{total}", this.state.pagination.total),
    };

    return (
      <div>
        {
          this.state.showLogDetail ?
            <UpstreamSyncerLogDetailPage syncId={this.props.syncerId} detail={this.state.record} dismiss={() => {this.setState({showLogDetail: false});}} />
            :
            <Table scroll={{x: "max-content"}} columns={columns} dataSource={records} rowKey="id" size="middle" bordered pagination={paginationProps}
              loading={this.state.loading}
              onChange={this.handleTableChange}
            />
        }

      </div>
    );
  }

  fetch = (params = {}) => {
    let field = params.searchedColumn, value = params.searchText;
    const sortField = params.sortField, sortOrder = params.sortOrder;
    if (params.isAuto !== undefined && params.isAuto !== null) {
      field = "isAuto";
      value = params.isAuto;
    } else if (params.status !== undefined && params.status !== null) {
      field = "status";
      value = params.status;
    }

    this.setState({loading: true});
    SyncerBackend.getUpstreamSyncerLog(this.props.syncerId, params.pagination.current, params.pagination.pageSize, field, value, sortField, sortOrder)
      .then((res) => {
        if (res.status === "ok") {
          this.setState({
            loading: false,
            data: res.data,
            pagination: {
              ...params.pagination,
              total: res.data2,
            },
            searchText: params.searchText,
            searchedColumn: params.searchedColumn,
          });
        }
      });
  };
}

export default UpstreamSyncerLogPage;
